import VueMask from 'v-mask'
import { VueConstructor } from 'vue'
import VueCookies from 'vue-cookies'
import VueObserveVisibility from 'vue-observe-visibility'
import { ValidationProvider } from 'vee-validate'

import AnalyticsPlugin from 'aven_shared/src/plugins/analytics'

// Vue 2.7 registers plugins/components on the global Vue constructor; on the Vue 3
// migration this function takes the `app` instance instead and the body is otherwise
// unchanged. Mirrors aven/src/config/initPlugins.ts to keep the migration diff small.
export const initPlugins = (vue: VueConstructor) => {
    // we need to register this component globally so that we can use it in aven_shared templates
    vue.component('ValidationProvider', ValidationProvider)

    vue.use(VueCookies)
    vue.use(VueObserveVisibility)
    vue.use(AnalyticsPlugin)

    vue.use(VueMask, {
        // This allows us to use the 'X' character as a regular char
        // https://github.com/probil/v-mask#default-placeholders
        placeholders: {
            X: null,
        },
    })
}
